import { makeAutoObservable, runInAction } from 'mobx'
import { http } from '@/utils'

class DeviceStore {

    //数据列表初始化
    dataList = [];

    selectList = [];
    selectList2 = [];
    selectList3 = [];
    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //表单收集
    valueData = {
        jd: 43,
        wd: 125
    }
    isJdWd = false
    //弹框状态初始化
    isActive = false

    //弹框名字
    title = ''

    //查询字段
    sbmc = ''

    //批量删除
    moreId = ''

    //用户id
    jrxtid = JSON.parse(window.localStorage.getItem('jrxtid')) || ''


    constructor() {
        makeAutoObservable(this)
    }

    //下拉
    getSelectList = async () => {
        const res = await http.get(`/adminapi/systemmanagement?page=${1}&pagesize=${5000}&jrxtid=${this.jrxtid}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.xtmc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList = newdata
            })
        }
    }

    getSelectList2 = async () => {
        const res = await http.get(`/adminapi/enterprisemanagement?page=${1}&pagesize=${5000}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.qymc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList2 = newdata
            })
        }
    }

    getSelectList3 = async () => {
        const res = await http.get(`/adminapi/unitmanagement?page=${1}&pagesize=${5000}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.dymc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList3 = newdata
            })
        }
    }


    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/equipmentmanagement?page=${this.page}&pagesize=${this.pagesize}&sbmc=${this.sbmc}`)
        if (res.data.code === 200) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.data.data.data))
                this.total = res.data.data.data.total
            })
        }
    }

    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`/adminapi/equipmentmanagement/${id}`)
        if (res.status) {
            this.getDataList()
        }
    }

    //添加
    getAddButtom = async (values) => {
        const res = await http.post(`/adminapi/equipmentmanagement`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }

    //修改
    getPutInformation = async (values) => {
        const res = await http.put(`/adminapi/equipmentmanagement/${this.valueData.aid}`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }
}

export { DeviceStore }